import React, { Component } from "react";
import { FormGroup, FormControl, ControlLabel } from "react-bootstrap";
import uniqueId                   from 'lodash/uniqueId';
import SortableMonthViewBlockList from "../../components/sortable/SortableMonthViewBlockList";
import Sortable from 'react-sortablejs';

export default class CreateMonthViewDayBlockRow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            block_data: {},
            exercise_names: [],
            block_ids: [],
            block_id: null
        }
    }

    compareObjs = (a,b) => {
          if (a.week_id < b.week_id)
            return -1;
          if (a.week_id > b.week_id)
            return 1;
          return 0;
    }

    render() {
        var ctr2         = 1;
        var i            = 1;
        var that         = this;
        var day_id       = this.props.day_id;
        var current_week = this.props.current_week;

        var blocksList2 =  <SortableMonthViewBlockList
                                className                = "trackMonthViewDayBlockList"
                                showDayModalSimple       = {this.props.showDayModalSimple}
                                getProgramDOMTree        = {this.props.getProgramDOMTree}
                                openAddNewExerciseModal  = {this.props.openAddNewExerciseModal}
                                editMonthViewExercise    = {this.props.editMonthViewExercise}
                                block_data               = {this.props.block_data /*state.data*/}
                                current_week             = {current_week}
                                duplicateBlock           = {this.props.duplicateBlock}
                                deleteBlock              = {this.props.deleteBlock}
                                setModalAlertProps       = {this.props.setModalAlertProps}
                                checkNumberOfBlocksInDay = {this.props.checkNumberOfBlocksInDay}
                                onChange                 = {(blocks_order, block_id, day_id, day_id_to, block_to_index) => {
                                    this.props.updateBlockData(blocks_order, block_id, day_id, day_id_to, block_to_index);
                                }}
                            />

        return blocksList2;
    }
}



// WEBPACK FOOTER //
// ./src/screens/program/CreateMonthViewDayBlockRow.js